module.exports = __webpack_public_path__ + "img/slide13_vn.80c374b4.jpg";